<app-loader *ngIf="(profileState | async).profileDetail === null" message="Loading audit report..."></app-loader>

<section class="audit-page" *ngIf="(profileState | async).profileDetail !== null">
  <app-breadcrumbs type="profileReport"></app-breadcrumbs>

  <app-tiktok-profile-title></app-tiktok-profile-title>

  <!-- Processing State -->
  <div class="status-card" *ngIf="(profileState | async).audit !== null && ((profileState | async).audit.status === 0 || (profileState | async).audit.status === 10) && (profileState | async).audit.bio !== null && (profileState | async).audit.bio.progress < 100">
    <div class="status-icon pulse">
      <i class="bi bi-hourglass-split"></i>
    </div>
    <h3>Report is being prepared</h3>
    <p class="text-muted">We analyze posts in real time and it may take a minute.</p>
    <div class="progress-track">
      <div class="progress-fill" [ngStyle]="{width: (profileState | async).audit.bio.progress + '%'}"></div>
      <span class="progress-label">{{(profileState | async).audit.bio.progress}}%</span>
    </div>
  </div>

  <app-profile-media-pro></app-profile-media-pro>

  <div *ngIf="(profileState | async).audienceTiktok !== null">
    <app-profile-audit-audience></app-profile-audit-audience>
  </div>
  <div *ngIf="(profileState | async).audienceTiktok === null">
    <app-profile-audit-audience-demo></app-profile-audit-audience-demo>
  </div>
</section>
